(() => {
  const update = (elem) => {
    const allOwnedItems = window.swinger.user.getAllOwnedItemNumbers();
    const ownedMovies = allOwnedItems.filter((item) => item.indexOf('-') === -1);
    const ownedScenes = allOwnedItems.filter((item) => item.indexOf('-') > -1);
    const likedCategories = window.swinger.user.getAllLikedItemNumbers('category');
    const kind = elem.getAttribute('data-kind');

    switch (kind) {
      default:
        break;

      case 'movies':
        elem.style.display = ownedMovies.length ? '' : 'none';
        break;

      case 'scenes':
        elem.style.display = ownedScenes.length ? '' : 'none';
        break;

      case 'categories':
        elem.style.display = likedCategories.length ? '' : 'none';
        break;
    }
  };

  window.swinger.observer.initialize('.swinger-library-slider', (elem) => {
    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    });

    update(elem);
  }, false);
})();
